class Modal extends HTMLElement {
  constructor() {
    super();

    this.modalType = 'simple';
    this.activeModalId = null;
    this.body = document.body;
    this.addEventListener('click', this.#handleClick.bind(this));
  }

  #open(modalId) {
    this.activeModalId = modalId;
    this.#update();
    this.body.classList.add('modal-active');
  }

  #close() {
    if (this.modalType === 'video') {
      pauseAllMedia();
    }

    this.modalType = 'simple';
    this.activeModalId = null;
    this.#update();
    this.body.classList.remove('modal-active');
  }

  #handleClick(e) {
    const openBtn = e.target.closest('[data-modal-open]');
    const closeBtn = e.target.closest('[data-modal-close]');
    const overlay = e.target.closest('[data-modal-overlay]');

    if (openBtn) {
      e.preventDefault();
      this.#open(openBtn.dataset.modalOpen);
      this.modalType = openBtn?.dataset.modalType;
    }

    if (closeBtn || overlay) {
      e.preventDefault();
      this.#close();
    }
  }

  #update() {
    this.#toggleModals();
  }

  #toggleModals() {
    const modals = this.querySelectorAll('[data-modal-id]');

    modals.forEach((modal) => {
      const isActive = modal.dataset.modalId === this.activeModalId;
      modal.toggleAttribute('open', isActive);

      const overlay = modal.querySelector('.modal__overlay');
      const modalInner = modal.querySelector('.modal');

      if (overlay) {
        overlay.classList.toggle('modal__overlay--active', isActive);
      }

      if (modalInner) {
        modalInner.classList.toggle('modal--active', isActive);
      }

      if (isActive && modal.querySelector('aw-video, .js-youtube, .js-vimeo')) {
        this.#playMedia(modal);
      }
    });
  }

  #playMedia(modal) {
    if (!modal) return;

    modal.querySelectorAll('aw-video').forEach((component) => {
      const triggerSelector = component.config?.trigger;
      if (!triggerSelector) return;

      const trigger = component.querySelector(triggerSelector);
      if (trigger) {
        trigger.click();
      }
    });

    modal.querySelectorAll('.js-youtube').forEach((iframe) => {
      iframe.contentWindow?.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      );
    });

    modal.querySelectorAll('.js-vimeo').forEach((iframe) => {
      iframe.contentWindow?.postMessage(
        '{"method":"play"}',
        '*'
      );
    });
  }
}

customElements.define('aw-modal', Modal);
